<template>
  <div class="content">
    <!-- 搜索条件 -->
    <div class="block block-form">
      <div class="block-tilte">资金明细</div>
      <el-form :model="searchForm" class="search-form">
        <el-form-item label="事件类型">
          <el-select v-model="searchForm.type" placeholder="请选择事件类型">
            <el-option v-for="item in type_list" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="收入类型">
          <el-select v-model="searchForm.is_income" placeholder="请选择收入类型">
            <el-option v-for="item in is_income_list" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="订单编号">
          <el-input v-model="searchForm.relation_id" placeholder="请输入订单编号" />
        </el-form-item>
        <el-form-item label="日期">
          <date-picker type="date" placeholder="开始日期" v-model="searchForm.start_time_bak" style="width: 150px;"
            @on-change="handelDateChangeStart"></date-picker>
          <span>至</span>
          <date-picker type="date" placeholder="结束日期" v-model="searchForm.end_time_bak" style="width: 150px;"
            @on-change="handelDateChange"></date-picker>
        </el-form-item>
        <el-form-item>
          <!-- 操作按钮 -->
          <el-button style="margin-left:12px" type="warning" :loading="listLoading" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
          <el-button :loading="exportLoading" @click="onFormExport">导出数据</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="block block-top">
      <Table border :columns="columns" :data="list" :loading="listLoading" :row-class-name="rowClassName">
        <template slot="thirdPartyStore" slot-scope="{ row }">
          <div>{{ formatDisplayValue(row.storeName) }}</div>
          <div>ID：{{ formatDisplayValue(row.storeId) }}</div>
        </template>
        <template slot="ticketSeller" slot-scope="{ row }">
          <div>{{ formatDisplayValue(row.sellerName) }}</div>
          <div>ID：{{ formatDisplayValue(row.sellerUUID) }}</div>
        </template>
      </Table>
      <div style="padding: 10px 0px">
        <Page :total="total" :current="searchForm.page" show-sizer show-elevator show-total @on-change="changePage"
          @on-page-size-change="changePagesize"></Page>
      </div>
    </div>
  </div>
</template>
<script>
import { Icon, Table, Page, Button, Select, Option, Input, DatePicker } from 'view-design'
import { getUserBalanceList } from '@/api/user'
import { getDate, formatDate } from '@/utils/date'
import { matchInteger } from "@/utils/regExp";
import { getUserUUID} from '@/utils/auth'
export default {
  name: 'PromotionOrder',
  components: {
    Icon,
    Table,
    Page,
    Button,
    Select,
    Option,
    Input,
    DatePicker
  },
  data: function () {
    return {
      uuidList:['6494077eb6eebdaa048f72b512114eba','66a0e6f4bff55772f7688c6ebf791f37'],
      columns: [
        {
          title: '明细时间',
          key: 'create_time'
        },
        {
          title: '事件类型',
          key: 'type_str'
        },
        {
          title: '明细说明',
          key: 'mingxi_detail',
        },
        {
          title: '第三方平台店铺',
          key: 'storeName',
          slot: 'thirdPartyStore'
        },
        {
          title: '出票票商',
          key: 'sellerName',
          slot: 'ticketSeller'
        },
        {
          title: '订单号',
          key: 'relation_id',
        },
        {
          title: '变动金额',
          key: 'amount'
        },
        {
          title: '变动后余额',
          key: 'after_amount'
        }
      ],
      listLoading: false,
      exportLoading: false,
      list: [],
      total: 0,
      searchForm: {
        page: 1,
        pagesize: 10,
        is_income: undefined,
        type: undefined,
        start_time_bak: undefined,
        end_time_bak: undefined,
        start_time: undefined,
        end_time: undefined,
        sort: '-id',
        relation_id: ''
      },
      is_income_list: [
        { value: '', label: '全部' },
        { value: '1', label: '收入' },
        { value: '2', label: '支出' }
      ],
      type_list: []
    }
  },
  created() {
    // this.getUUID()
    this.setTimeBak()
    this.getList(true)
  },
  methods: {
    setTimeBak() {
      // 默认时间选择框下单时间为7天
      this.searchForm.start_time_bak = new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000)
      this.searchForm.end_time_bak = new Date()
    },
    getUUID() {
      let uid = getUserUUID()
      if(this.uuidList.includes(uid)) {
        const index = this.columns.findIndex(item => item.key === 'after_amount')
        if(index > -1) {
          this.columns.splice(index, 1)
        }
      }
    },
    formatDisplayValue(value) {
      return value === null || value === undefined || value === '' ? '-' : value
    },
    getList(first = false) {
      this.listLoading = true
      if (first) this.searchForm.page = 1
      let searchForm = Object.assign({}, this.searchForm)
      searchForm.start_time = getDate(searchForm.start_time_bak)
      searchForm.end_time = getDate(searchForm.end_time_bak)
      delete searchForm.start_time_bak
      delete searchForm.end_time_bak
      getUserBalanceList(searchForm).then((response) => {
        this.listLoading = false
        if (response.code != 200) {
          this.$Message.error(response.msg)
          return
        }
        this.list = response.data.list
        this.total = response.data.total
        this.type_list = response.data.type_list
      }).catch(error => {
        this.listLoading = false
        console.log(error)
      })
    },
    rowClassName: function (row, index) {
      if (index % 2 === 0) {
        return 'bg-fa'
      }
      else {
        return 'bg-white'
      }
    },
    onFormSearch() {

      // 验证订单号
      if (
        this.searchForm.relation_id &&
        this.searchForm.relation_id.length
      ) {
        if (!matchInteger.test(this.searchForm.relation_id)) {
          this.$message.error("请输入正确的订单号");
          return;
        }
      }


      this.getList(true)
    },
    onFormReset() {
      this.searchForm.is_income = ''
      this.searchForm.type = ''
      this.searchForm.start_time_bak = ''
      this.searchForm.end_time_bak = ''
      this.searchForm.start_time = ''
      this.searchForm.end_time = ''
      this.searchForm.relation_id = ''
      this.setTimeBak()
      this.getList()
    },
    changePage(value) {
      this.searchForm.page = value
      this.getList()
    },
    changePagesize(value) {
      this.searchForm.pagesize = value;
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchForm.page == 1) {
        this.getList()
      }
    },
    handelDateChange: function (time, type) {
      if (type == 'date') {
        if (this.searchForm.start_time_bak !== '') {
          if (this.compareTime(this.searchForm.start_time_bak, time)) {
            this.searchForm.end_time_bak = this.searchForm.start_time_bak;
          }
        }
      }
    },
    handelDateChangeStart: function (time, type) {
      if (type == 'date') {
        if (this.searchForm.end_time_bak !== '') {
          if (this.compareTime(time, this.searchForm.end_time_bak)) {
            this.searchForm.start_time_bak = this.searchForm.end_time_bak;
          }
        }
      }
    },
    compareTime: function (startTime, endTime) {
      var oDate1 = new Date(startTime);
      var oDate2 = new Date(endTime);
      if (oDate1.getTime() > oDate2.getTime()) {
        return true
      } else {
        return false
      }
    },
    onFormExport: function () {
      if (this.exportLoading) return
      this.exportLoading = true
      let searchForm = Object.assign({}, this.searchForm)
      searchForm.page = 1
      searchForm.pagesize = 50000
      searchForm.start_time = getDate(searchForm.start_time_bak)
      searchForm.end_time = getDate(searchForm.end_time_bak)
      delete searchForm.start_time_bak
      delete searchForm.end_time_bak
      getUserBalanceList(searchForm).then(async res => {
        console.log(res,'res=======1')
        const code = res.code
        const message = res.message
        if (code === 200) {
          await this.$alert(`当前数据下载中，请前往 导出中心 查看`, '导出数据提示', {
            showCancelButton: true,
            confirmButtonText: '前往导出列表',
            cancelButtonText: '取消',
            callback: action => {
              if(action === 'confirm'){
                this.$router.push({ path: "/pc/exportCenter/index" });
              }
              this.exportLoading = false
            }
          });
        } else {
          this.$Message.error(message)
        }
        // if (res.code != 200) {
        //   this.$message.error(res.message)
        //   return
        // }
        // let filename = "资金明细" + formatDate("yyMMddhhmmss")
        // let header = ['明细时间', '事件类型', '明细说明', '订单号', '变动类型', '变动后余额']
        // let data = res.data.list.map(x => {
        //   return [x.create_time, x.type_str, x.mingxi_detail, x.relation_id, x.amount, x.after_amount]
        // })
        // import('@/vendor/Export2Excel').then(excel => {
        //   excel.export_json_to_excel({
        //     header,
        //     data,
        //     filename
        //   })
        //   this.$message.success('导出成功')
        // })
      }).catch(error => {
        // this.$message.error(error.toString())
      }).finally(() => {
        this.exportLoading = false
      })
    },
  }
}
</script>
<style scoped>
.wrapper {
  width: 100%;
}

.wrapper .tilte-text {
  font-size: 20px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper .table-wrapper {
  margin-top: 0.62rem;
}

.table-wrapper .show-excel {
  font-size: 14px;
  color: #ff4f76;
  cursor: pointer;
  display: inline-block;
  padding-right: 7px;
}

.table-wrapper .show-excel:last-child {
  padding-right: 0px;
}

.input-search {
  width: 150px;
  height: 30px;
  height: 32px;
  line-height: 1.5;
  padding: 4px 7px;
  font-size: 14px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  color: #515a6e;
}

input::placeholder {
  font-size: 14px;
  color: #c5c8ce !important;
}

.block-tilte {
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  margin-bottom: 24px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/money/Index.vue